/* eslint-disable jsx-a11y/anchor-is-valid */

import {FC, useState} from 'react'
import clsx from 'clsx'
import {PageTitle} from '../../../../../../../_metronic/layout/core'
import {TableCheckingWrapper} from "../components/Tables/TableCheking";

const CheckingPage: FC = () => {
  const [tab, setTab] = useState('Sidebar')
  return (
    <>
      <div className='card card-custom'>
        <div className='card-header card-header-stretch overflow-auto'>
          <ul
            className='nav nav-stretch nav-line-tabs
            fw-bold
            border-transparent
            flex-nowrap
          '
            role='tablist'
          >
            <li className='nav-item'>
              <a
                className={clsx(`nav-link cursor-pointer`, {active: tab === 'Sidebar'})}
                onClick={() => setTab('Sidebar')}
                role='tab'
              >
                Reservas2
              </a>
            </li>
            <li className='nav-item'>
              <a
                className={clsx(`nav-link cursor-pointer`, {active: tab === 'Header'})}
                onClick={() => setTab('Header')}
                role='tab'
              >
                Agregar Reserva
              </a>
            </li>
            <li className='nav-item'>
              <a
                className={clsx(`nav-link cursor-pointer`, {active: tab === 'Toolbar'})}
                onClick={() => setTab('Toolbar')}
                role='tab'
              >
                Editar Reserva
              </a>
            </li>
          </ul>
        </div>
        <div className='tab-content pt-3'>
          <div className={clsx('tab-pane', {active: tab === 'Sidebar'})}></div>
          <div className={clsx('tab-pane', {active: tab === 'Header'})}></div>
          <div className={clsx('tab-pane', {active: tab === 'Toolbar'})}></div>
        </div>
      </div>
      <TableCheckingWrapper />
    </>
  )
}

const CheckingPageWrapper: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={[]}>Check in</PageTitle>
      <CheckingPage />
    </>
  )
}

export default CheckingPageWrapper
